<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?'编辑分类':'新增分类'" :visible.sync="dialog" @close="unShowClick()" width="40%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item v-if="topId" label="父级分类名称" prop="" :label-width="formLabelWidth">
					<el-select :disabled='topId' style="width: 100%;" v-model="addBody.pid" placeholder="请输入父级分类名称">
						<el-option v-for="item in pids" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="分类名称" prop="name" :label-width="formLabelWidth">
					<el-input style="width: 100%;" v-model="addBody.name" placeholder="请输入分类名称"></el-input>
				</el-form-item>
				<el-form-item label="权重" prop="weight" :label-width="formLabelWidth">
					<el-input type='number' style="width: 100%;" v-model="addBody.weight" placeholder="请输入权重"></el-input>
					<div style="color: #999;">*权重数字越大排序越靠前</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="updateCourseCate('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getCourseCateList,
		addCourseCate,
		updateCourseCate,
		getCourseCateDetail
	} from '@/api/course'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					name: '',
					pid: '',
					weight: "",
					uuid: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					},  {
							min: 1,
							max: 30,
							message: '最大30个字符',
							trigger: 'blur'
						}],
					weight: [{
						required: true,
						message: '请输入权重',
						trigger: 'blur'
					}, {
						// 匹配大于0的数字（包括整数和小数）
						pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
						message: '必须输入大于0的数字',
						trigger: ['blur', 'change']
					}],
					pid: [{
						required: true,
						message: '请选择上级分类',
						trigger: 'change'
					}, ],
				},
				weightList: [],
				weight: '',
				isEdit: false,
				pids: [],
				topId: false
			}
		},
		mounted() {
			
		},
		methods: {
			async getCourseCateList() {
				const {
					status,
					data
				} = await getCourseCateList({
					page_size: 999,
					page_index: 1,
				})
				this.pids = data.result.data
			},
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			updateCourseCate(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().updateCourseCate()
						} else {
							this.network().addCourseCate()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.topId = false
				this.$emit('input', false)
			},
			network() {
				return {
					addCourseCate: async () => {
						const {
							status,
							data
						} = await addCourseCate({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					updateCourseCate: async () => {
						const {
							status
						} = await updateCourseCate({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getCourseCateDetail: async (uuid) => {
						const {
							data,
							status
						} = await getCourseCateDetail({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.images = []
				if (val.uuid) {
					this.isEdit = true;
					this.network().getCourseCateDetail(val.uuid)
				} else {
					this.isEdit = false
					this.addBody.name = ''
					this.addBody.pid = ''
					this.addBody.weight = ''
					this.addBody.uuid = ''
				}
				if (val.topId) {
					this.addBody.pid = val.topId
					this.getCourseCateList()
					this.topId = true
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>